import { combineReducers } from 'redux';
import registration from './reducers/registration';
import pantry from './reducers/pantry';

const rootReducer = combineReducers({
  registration,
  pantry,
});

export default rootReducer;
